import {
	endpointsMap,
	IFindNearestStoreOptions,
	IFindNearestStoreResponse,
	IGetStoresOptions,
	IGetStoresResponse,
	IGetStoreOptions,
	IGetStoreResponse
} from './ICustomShopperStores';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperStores
 */
class CustomShopperStores extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Gets the stores near the coordinates passed
	 * @param {IGetStoresOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IGetStoresResponse} - Array of Stores
	 */
	public async getStores(fetchOptions: IGetStoresOptions, throwOnError?: boolean): Promise<IGetStoresResponse> {
		const response: IGetStoresResponse = await this.callCustomEndpoint<IGetStoresResponse>(
			fetchOptions,
			endpointsMap.GET_STORES
		);

		if (throwOnError && !response.stores) {
			throw new Error('Stores API Error');
		}

		return response;
	}

	/**
	 * Gets the stores near the coordinates passed
	 * @param {IGetStoresOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IGetStoreResponse} - Store
	 */
	public async getStore(fetchOptions: IGetStoreOptions, throwOnError?: boolean): Promise<IGetStoreResponse> {
		const response: IGetStoreResponse = await this.callCustomEndpoint<IGetStoreResponse>(
			fetchOptions,
			endpointsMap.GET_STORE
		);

		if (throwOnError && !response.store) {
			throw new Error('Store not found');
		}

		return response;
	}

	/**
	 * Gets the nearest store based on request geolocation
	 * @param {IFindNearestStoreOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IFindNearestStoreResponse} - Nearest Store
	 */
	public async findNearestStore(
		fetchOptions: IFindNearestStoreOptions = {},
		throwOnError?: boolean
	): Promise<IFindNearestStoreResponse> {
		const response: IFindNearestStoreResponse = await this.callCustomEndpoint<IFindNearestStoreResponse>(
			fetchOptions,
			endpointsMap.FIND_NEAREST_STORE
		);

		if (throwOnError && response.store === undefined) {
			throw new Error('Nearest store API Error');
		}

		return response;
	}
}

export default CustomShopperStores;
